import React from 'react' // { useEffect }
import { makeStyles, createStyles, Box } from '@material-ui/core/'
import { useTranslation } from 'react-i18next'
import LoadingIcon from 'src/mobile/themes/components/LoadingIcon'
// import EmptyDataIcon from 'src/mobile/assets/icons/errorStatus/empty.png'

const useStyles = makeStyles((theme) =>
  createStyles({
    img: {
      display: 'block',
      maxWidth: theme.spacing(15),
    },
    button: {
      minWidth: theme.spacing(17),
      height: theme.spacing(4.5),
    },
    clearBtn: {
      cursor: 'pointer',
      width: 162,
      height: 56,
      border: '1px solid #D1D5DB',
      borderRadius: 8,
      fontWeight: 600,
      fontSize: 16,
      textAlign: 'center',
      paddingTop: 16,
    },
  }),
)

const Loading = (props, title) => {
  console.log(title)
  console.log(title.length)
  const { t } = useTranslation()
  const classes = useStyles()
  return (
    <Box
      minHeight={120}
      justifyContent="center"
      display="flex"
      flexDirection="column"
      alignItems="center"
      my="auto"
      py={2}
    >
      {props.status === 'pending' || !props.status ? (
        <LoadingIcon />
      ) : (
        <>
          {/* {!props.hideImg && <img className={classes.img} src={EmptyDataIcon} alt="empty image" />} */}
          <Box fontSize={26} fontWeight={600} className={classes.a}>
            {t('glossary.no_result')}
            {/* {title?.length
              ? t('glossary.faq.no_result')
              : t('tips.empty_data', { field: '$t(glossary.faq)' })}{' '} */}
          </Box>
          <Box
            width={406}
            fontSize={18}
            fontWeight={400}
            margin="24px"
            marginTop={3}
            marginBottom={4}
            textAlign="center"
          >
            {t('glossary.faq_sorry')}
          </Box>
          <Box
            className={classes.clearBtn}
            onClick={() => {
              props.changeclearbtn(true)
            }}
          >
            {t('glossary.clearkey')}
          </Box>
          {/* <Box mt={2} fontSize="subtitle1.fontSize" textAlign="center" color="grey.400" className={classes.a}>

            <Box mb={1} fontSize="h4.fontSize" color="grey.800" fontWeight="fontWeightMedium">
              {props.title || t('tips.can_not_get_data')}
            </Box>
            <Box fontSize="body1.fontSize" color="grey.400">
              {props.subTitle || ''}
            </Box>
          </Box> */}
        </>
      )}
    </Box>
  )
}

export default Loading
